import FieldConfig from "../../proto/field-config"
import FieldMultiselect from "../multiselect/multiselect"
import {GROUP_INFO} from "../../../gd/const/fields/field2-groups"
import FieldTags_AutomationActionForm from "./render/automation-action-form"
import mapTag from "../../import/normalize/map-tag"
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module"
import FieldTags_PopoverMenu from "./components/popover/popover-menu"
import FieldTag_Pill from "./components/pill"
import FieldTags_PopoverMenuMore from "./components/popover/more"
import FieldTags_Editable from "./render/editable/editable"
import {ProjectSystemType} from "../../../model2/project/types"
import ProjectSession from "../../../model2/project/project-session"
import FieldTag_ViewProperty from "./render/view-property"
import {FieldFilterType} from "../../proto/types"
import FieldTags_Picker from "./render/picker"
import FieldTags_FormElement from "./render/form/form-element"
import FieldTags_FormElementView from "./render/form/form-element-view"
import {TagScope} from "../../../model2/tag/const";
import Task from "../../../model2/task/task";

// created for and currently used in automations only
// some modifications may be required to use it somewhere else if needed
export default class FieldTags extends FieldMultiselect {

    public isLoaded     : boolean

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Tags"
        this.filterType         = FieldFilterType.MULTISELECT
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Tags field"
        this.icon               = 'i5-tag'

        // special
        this.options            = []
        this.isLoaded           = gd.session.loader.tagsLoaded
        this.refreshOptions()

        this.classes.PopoverMenuScrollContainer     = ''

        this.renderComponents.automationActionForm  = FieldTags_AutomationActionForm
        this.renderComponents.editable              = FieldTags_Editable
        this.renderComponents.viewProperty          = FieldTag_ViewProperty
        this.renderComponents.picker                = FieldTags_Picker
        this.renderComponents.formElement           = FieldTags_FormElement
        this.renderComponents.formElementView       = FieldTags_FormElementView
        // this.renderComponents.automationTriggerForm = FieldTags_AutomationTriggerForm

        this.components.PopoverMenu                 = FieldTags_PopoverMenu
        this.components.PopoverMenuMore             = FieldTags_PopoverMenuMore

        this.components.Pill                        = FieldTag_Pill

        // this.filterValuesFiller                     = FieldMultiselect_filterValuesFiller
    }

    // loads tags data if needed (shared/cached via gd.session.loader) then refreshes options from session
    async loadOptions(callback?:callback): Promise<void> {
        if (!this.isLoaded) {
            await gd.session.loader.loadTags()

            this.refreshOptions()
            this.isLoaded = true
        }

        callback?.()
    }

    // recomputes options from session tags - call again once gd.session.loader.tagsLoaded becomes true
    // if this field was constructed before tags were loaded
    refreshOptions() {
        // single pass over projects.models instead of chaining filterByCompany().filterBySystemType(),
        // which would allocate two intermediate ProjectSessionCollection instances (each building a byId map we never use)
        this.options = _(gd.session.projects.models)
            .filter((project:ProjectSession) => {
                return project.companyId===gd.companyId && project.systemType===ProjectSystemType.TAG
            })
            .map((tag:ProjectSession) => {
                return {
                    value: tag.id,
                    color: tag.color,
                    label: tag.name
                }
            })
            .value()
    }

    // model is optional on purpose - it is only known when we offer tags to choose from (popover
    // menu). Value rendering (_getOptions() -> pills, view, sort, search, CSV) has no model and
    // must show every tag the value refers to, so with no model we return the options unfiltered
    getOptions(model?: Task) {
        const options = super.getOptions()

        if (!model) return options

        return _.filter(options, (option: Option) => {
            const tag = gd.session.projects.get(option.value)

            // unknown tag (i.e. not loaded) or the no value option - keep it, we can not judge its scope
            if (!tag) return true

            if (tag.tagScope !== TagScope.PROJECT) return true

            if (!model.projectId || !tag.parentId) return false

            // available in the tag parent project and in all of its subprojects
            if (tag.parentId === model.projectId) return true

            return _.includes(gd.session.projects.getAllParentsIds(model.projectId), tag.parentId)
        })
    }

    getOptionsForEdit(model: Task) {
        return this.getOptions(model)
    }

    normalizeToCSVValue(model: any): any {
        const rawValue = super.normalizeToCSVValue(model)

        const getTagName = (tagId: string) => {
            const tag = gd.session.projects.get(tagId)
            return tag ? tag.name : ''
        }

        return _(rawValue).map(id=>getTagName(id)).compact().value().join(', ')
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        if (!value) return

        let errors: boolean  = false

        let tagNames: string[] = value.split(module.multiValueDelimiter)
        tagNames = _.map(tagNames, (tagName: string) => tagName.trim())

        const tags: string[] = []
        _.map(tagNames, (tagName: string): void => {
            const tagId = mapTag(tagName)
            if (tagId) {
                tags.push(tagId)
            } else {
                tags.push(tagName)
                errors = true
            }
        })

        if (errors) return

        return tags
    }
}
